var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMusicNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  viewBox: "0 0 24 24"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 6,
  cy: 18.2,
  rx: 2.6,
  ry: 2.2
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.4,
  cy: 16.2,
  rx: 2.6,
  ry: 2.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.6 18.2V6.6L20 4.4v11.8M8.6 9.4 20 7.2"
})));
export { SvgMusicNote as ReactComponent };